var React = require('react');

function ArrowLeftCarousel (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.059 13.98l9.607 9.606L12.25 25 .938 13.686.23 12.98l.708-.707L12.25.958l1.415 1.415-9.607 9.606h31.527v2H4.059z","fill":"url(#paint0_linear)","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear","x1":"5.651","y1":"22.009","x2":"33.986","y2":"-9.967","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"stopColor":"#3D7DFF","key":0}),React.createElement("stop",{"offset":".49","stopColor":"#5C5CE5","key":1}),React.createElement("stop",{"offset":"1","stopColor":"#E54C4C","key":2})]))]);
}

ArrowLeftCarousel.defaultProps = {"width":"36","height":"25","viewBox":"0 0 36 25","fill":"none"};

module.exports = ArrowLeftCarousel;

ArrowLeftCarousel.default = ArrowLeftCarousel;
